import { UUID } from 'v2/core/entities/uuid';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

function fixNormalisedNodeValue(
  node: NormalisedNode,
  nodes: Record<UUID, NormalisedNode>,
) {
  if (node.type === 'filter') {
    if (node.field === 'source') {
      switch (node.value.type) {
        case 'boolean':
        case 'number':
        case 'string': {
          try {
            if (node.value.value) {
              const dataObj = JSON.parse(String(node.value.value));
              if (dataObj.name) {
                const namespace = dataObj.namespace
                  ? `-${dataObj.namespace}`
                  : '';
                node.value.value = dataObj.name + namespace;
              }
            }
          } catch (e) {}
          return;
        }
        case 'boolean[]':
        case 'number[]':
        case 'string[]':
          try {
            const values = node.value.values;
            values?.forEach(({ value }, index) => {
              const dataObj = JSON.parse(String(value));
              if (dataObj.name) {
                const namespace = dataObj.namespace
                  ? `-${dataObj.namespace}`
                  : '';
                values[index].value = dataObj.name + namespace;
              }
            });
          } catch (e) {}
      }
    }
  }

  if (node.type === 'group') {
    node.children.forEach((child) => {
      fixNormalisedNodeValue(nodes[child], nodes);
    });
  }
}

export function fixNormalisedNodeValues(nodes: Record<UUID, NormalisedNode>) {
  Object.values(nodes).forEach((node) => {
    fixNormalisedNodeValue(node, nodes);
  });
}
